import React, { useState, useContext, useEffect } from "react"
import tw from "twin.macro"
import TranslateClient from "../../clients/TranslateClient"
import { getStringValuesArray, mapValuesToObject } from "../../helpers"
import { LanguageContext } from "../../context/Language"

import HeaderSettingsLanguage from "./HeaderSettingsLanguage"
import Accessibility from "../Icons/Accessibility"

const HeaderSettings: React.FC = () => {
  const wifiText = "Free Wifi Network"
  const [text, setText] = useState({ wifiText })
  const { language } = useContext(LanguageContext)

  useEffect(() => {
    if (language === "en") {
      setText({ wifiText })
    } else {
      ;(async () => {
        const textToTranslate = getStringValuesArray([wifiText])
        const translations = await TranslateClient.translate(
          textToTranslate,
          language
        )
        const translated = mapValuesToObject(text, translations)
        setText(translated)
      })()
    }
  }, [language])

  const handleAccessibilityClick = () => {
    if (typeof loadService === "function") {
      loadService()
    }
  }

  return (
    <div css={[tw`hidden xl:flex text-white self-end mt-2`]}>
      <div css={[tw`text-sm flex items-center`]}>
        <HeaderSettingsLanguage />
        <div
          css={[tw`tracking-tightest py-2 pl-5 text-3.75 font-light`]}
          aria-label="wifi"
        >
          {text?.wifiText}: <span css={[tw`font-semibold`]}>BHMFREEWIFI</span>
        </div>
        <div css={[tw`pl-5`]}>
          <button
            id="enableRecite"
            onClick={handleAccessibilityClick}
            aria-label="Enable accessibility tool"
            css={[
              tw`hover:(cursor-pointer bg-white text-black) transition-colors duration-500 rounded p-2 text-white hidden 2xl:flex gap-2 items-center`,
              tw`focus:(outline-none ring-2 ring-white ring-offset-2 ring-offset-transparent)`,
              tw`border-0 bg-transparent`,
            ]}
          >
            <Accessibility styling={[tw`h-5 w-5 stroke-current`]} />
            Accessibility Tool
          </button>
        </div>
      </div>
    </div>
  )
}

export default HeaderSettings
